// @mui material components
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import ProductsApi from "api/products";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function ActionCell({ promotionId, onDataUpdate }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const handleDeleteProduct = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found in localStorage.");
      return;
    }

    ProductsApi.DeletePromotedProduct(promotionId, token)
      .then((response) => {
        setOpen(false);
        onDataUpdate();
      })
      .catch((error) => {
        console.error(error.response?.data?.msg || error.message);
        setOpen(false);
      });
  };

  return (
    <SoftBox display="flex" alignItems="center">
      <SoftTypography
        variant="body1"
        color="secondary"
        sx={{ cursor: "pointer", lineHeight: 0 }}
      >
        {/* <Tooltip title="Aperçu de la promotion" placement="top">
          <Icon>visibility</Icon>
        </Tooltip> */}
      </SoftTypography>
      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          color="secondary"
          sx={{ cursor: "pointer", lineHeight: 0 }}
        >
          <Tooltip title={t("Modifier la promotion")} placement="top">
            <Link
              to={`/gestion-des-promotions/modifier-la-promotion/${promotionId}`}
            >
              <Icon>edit</Icon>
            </Link>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
      <SoftTypography
        variant="body1"
        color="secondary"
        sx={{ cursor: "pointer", lineHeight: 0 }}
        onClick={() => setOpen(true)}
      >
        <Tooltip title={t("Supprimer la promotion")} placement="left">
          <Icon>delete</Icon>
        </Tooltip>
      </SoftTypography>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">
          {t("Supprimer la promotion")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            {t("Êtes-vous sûr de vouloir supprimer cet promotion ?")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            {t("Non")}
          </Button>
          <Button onClick={handleDeleteProduct} color="primary" autoFocus>
            {t("Oui")}
          </Button>
        </DialogActions>
      </Dialog>
    </SoftBox>
  );
}

export default ActionCell;
